import React from 'react';
import { Modal } from '../../../../../../CommonComponents/OPL/Modal/Modal';
import { ModalHeader } from '../../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalCloseButton } from '../../../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalBody } from '../../../../../../CommonComponents/OPL/Modal/ModalBody';
import { Select } from '../../../../../../CommonComponents/OPL/Select/Select/Select';
import { CharitableGivingOptions } from '../../../../api/useGoalsQuery';
import { GivingStrategy } from '../../../../../../CharitableGivingWorkflow/stages/CharitableGiving/api/useCharitableGivingQuery';
import { CharitableGoalDataDTO } from '../../CharitableGiving.meta';
import { GoalComponentProps } from '../../../../components/Goal/Goal.meta';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';

interface Props extends GoalComponentProps<CharitableGoalDataDTO> {
  options: CharitableGivingOptions;
  onChange: (value: GivingStrategy) => void;
}

export const EmptyForm = ({ onClose, onChange, options, name }: Props) => {
  const { givingStrategyOptions } = options;

  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={false}
      aria={{ labelledby: 'upsert-goal-modal--header' }}
    >
      <ModalHeader as="h2" id="upsert-goal-modal--header">
        Add {name} Goal
      </ModalHeader>

      <ModalCloseButton onClick={onClose} />

      <ModalBody>
        <Box minHeight="300px">
          <Select
            label="Giving Strategy"
            value={null}
            options={givingStrategyOptions}
            onChange={opt => {
              onChange(opt?.value || givingStrategyOptions[0].value);
            }}
            isPortal
          />
        </Box>
      </ModalBody>
    </Modal>
  );
};
